'use client';

import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { useState } from 'react';

import MoreSvg from '@/components/Icon/svgs/more.svg';
import type { ICircleConversation } from '@/service/friend';
import CircleProfileModal from '@/ui/PAHome/components/CircleProfileModal';

import styles from './index.less';

interface IProps {
  className?: string;
  iconClassName?: string;
  circleConversation?: ICircleConversation | null;
}

const MoreIcon = (props: IProps): JSX.Element => {
  const { className, iconClassName, circleConversation } = props;
  const [_open, setOpen] = useState<boolean>(false);

  return (
    <>
      <div
        className={classNames(styles.buttonItem, className)}
        id="moreIcon"
        onClick={() => {
          setOpen(true);
        }}
      >
        <Icon className={classNames(styles.icon, iconClassName)} component={MoreSvg} />
      </div>

      {circleConversation && (
        <CircleProfileModal
          circleConversation={circleConversation}
          circleRoute={circleConversation.circle.route}
          open={_open}
          setOpen={setOpen}
        />
      )}
    </>
  );
};

export default MoreIcon;
